import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { EnvironmentService } from '../environment/environment.service';

@Pipe({
  name: 'assetPath',
  pure: true
})
@Injectable({
  providedIn: 'root'
})
export class AssetPathPipe implements PipeTransform {
  pathToAssets: string;
  constructor(readonly envService: EnvironmentService) {
    this.pathToAssets = envService.pathToAssets;
  }

  transform(path: string): string {
    if (path && this.pathToAssets && typeof path === 'string' && path.match(/^\/assets\//)) {
      return this.pathToAssets + path;
    }
    return path;
  }
}
